import calendar from './calendar'
import select   from './select'

export default
{
    calendar,
    select
};
